import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { greys, font } from 'assets/themes/theme-default'
import { Button } from '../../index'

const StyledButton = styled(Button)`
  &&& {
    background-color: ${props => (isMobile ? props.theme.colors.color1.bg : greys.light4)};
    border-color: ${props => props.theme.colors.color1.bg};
    color: ${props => (isMobile ? '#fff' : props.theme.colors.color1.bg)};
    border-radius: 24px;
    padding: 0 10px;
    text-transform: uppercase;
    font-size: ${font.size.base};
    min-width: 165px;

    i {
      padding: ${isMobile && '8px'};
      color: ${props => (isMobile ? '#fff' : props.theme.colors.color1.bg)};
      margin-right: ${isMobile ? '0px' : '25px'};
    }
  }
  :disabled {
    opacity: 0.5;
  }
`

const ButtonPrev = props => {
  const { children } = props

  return (
    <StyledButton {...props} data-test="component-prev-button">
      {children}
      {/* {isBrowser && children} */}
      {/* {isMobile && <Icon type="left" data-test="prev-button-icon" />} */}
    </StyledButton>
  )
}

ButtonPrev.propTypes = {
  children: PropTypes.any
}

export default ButtonPrev
